import { FormHelperText, InputLabel, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import styles from "./styles";
import CustomAutocompleteProps, { Item } from "./types";

const CustomAutoComplete = ({
  id,
  label,
  // initial,
  // name,
  items,
  value,
  onChange,
  errorMessage = "",
  multiple = false,
  // multiline = false,
  handleDeleteChip,
  placeholder,
  style,
  sx,
  size,
  colorCircle,
  optionStyle,
  ...props
}: CustomAutocompleteProps) => {
  return (
    <div style={{ ...style }}>

      <Autocomplete<Item>
        {...props}
        size={size}
        value={value}
        options={items}
        // defaultValue={intial}
        onChange={onChange}
        multiple={multiple}
        getOptionLabel={(option) => option.name}
        renderInput={(selected) => {
          return <TextField {...selected} label={label} placeholder={placeholder} />;
        }}
        sx={{
          ...styles.select_field_text,
          ...sx,
        }}
        style={sx as undefined}
      ></Autocomplete>
      <FormHelperText id="error_text" sx={styles.error_message}>
        {errorMessage}
      </FormHelperText>
    </div>
  );
};

export default CustomAutoComplete;
